import { render, staticRenderFns } from "./DetailAppeal.vue?vue&type=template&id=1f99b07a&scoped=true&"
import script from "./DetailAppeal.vue?vue&type=script&lang=js&"
export * from "./DetailAppeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f99b07a",
  null
  
)

export default component.exports